var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.589e959cce3260ce2eda4b6d8c01026f.svg#l';
                    var viewUrl = 'sprites.589e959cce3260ce2eda4b6d8c01026f.svg#view-l';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };